import axios from '../lib/dm_axios';
import path from '../config/path';
const apiRootPath = path.apiRootPath;

var Controller = {};

Controller.claimPack = async function(collectible) {
  try {
    var pack = await axios.post(
      `${apiRootPath}collectibles/${collectible._id}/packs/claim`,
      {}
    );
    return pack;
  } catch (err) {
    console.log(err);
  }
};

Controller.purchasePack = async function(collectible, purchaseOption) {
  try {
    var pack = await axios.post(
      `${apiRootPath}collectibles/${collectible._id}/packs/purchase`,
      { purchaseOption }
    );
    return pack;
  } catch (err) {
    console.log(err);
  }
};

Controller.getMoments = async function(token, collectible) {
  try {
    var result = await axios.get(
      `${apiRootPath}collectibles/${collectible._id}/moments`,
      {
        headers: {
          auth: token,
        },
      }
    );
    return result.data;
  } catch (err) {
    console.log(err);
  }
};

Controller.getCollectibleStatus = async function(collectible) {
  try {
    var collectibles = await axios.get(
      `${apiRootPath}collectibles/${collectible._id}/status`
    );
    return collectibles;
  } catch (err) {
    console.log(err);
  }
};

Controller.getCollectibles = async function() {
  try {
    var collectibles = await axios.get(apiRootPath + 'collectibles');
    return collectibles;
  } catch (err) {
    console.log(err);
  }
};

Controller.getAllCollectibles = async function() {
  try {
    var collectibles = await axios.get(apiRootPath + 'collectibles/all');
    return collectibles;
  } catch (err) {
    console.log(err);
  }
};

Controller.getCollectible = async function(collectibleId) {
  try {
    var collectibles = await axios.get(
      apiRootPath + `collectibles/${collectibleId}`
    );
    return collectibles;
  } catch (err) {
    console.log(err);
  }
};

Controller.getToken = async function(collectibleId, tokenId) {
  try {
    var collectibles = await axios.get(
      apiRootPath + `collectibles/${collectibleId}/tokens/${tokenId}`
    );
    return collectibles;
  } catch (err) {
    console.log(err);
  }
};

Controller.getTokens = async function() {
  try {
    var tokens = await axios.get(apiRootPath + 'collectibles/tokens');
    return tokens;
  } catch (err) {
    console.log(err);
  }
};

export default Controller;
